import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { E_ShareType } from '@eureka/services/src/types/share';

export enum LinkStatus {
    INVALID = 'INVALID',
    VALID = 'VALID',
    EXPIRED = 'EXPIRED'
}
interface ShareData {
    data_id: string;
    data_type: E_ShareType;
    link_status: LinkStatus;
}

export const ShareApiService = Symbol('ShareApiService');

export interface ShareApiService {
    parseShare(share_id: string): Promise<ShareData>;
}
@injectable()
export class ShareApiServiceImpl extends PsHttpService implements ShareApiService {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    parseShare(share_id: string) {
        return this.get<PatSnapCommonResponseData<ShareData>>({
            url: `/share/${share_id}`,
        }).then((res) => {
            return res.data as ShareData;
        })
    }
}
